import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faBuilding,
  faCheckCircle,
  faChevronCircleLeft,
  faCog,
  faDesktop,
  faFileAlt,
  faLock,
  faSignInAlt,
  faTimesCircle,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faDesktop,
  faCog,
  faUserCircle,
  faLock,
  faSignInAlt,
  faFileAlt,
  faBuilding,
  faChevronCircleLeft,
  faCheckCircle,
  faTimesCircle
);

export { FontAwesomeIcon };
